import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CadAsyncDocumentsService } from './services/cad-async-document.service';
import { CadLockService } from './services/cad-lock.service';
import { DeclarationsService } from './services/declarations.service';
import { CadDraftService } from './services/cad-draft.service';
import { CadService } from './services/cad.service';
import { DutyDrawbackDraftService } from './services/ddb-draft.service';
import { DutyDrawbackService } from './services/ddb.service';
import { DeclarationsAsyncValidatorsService } from './services/declarations-validators.service';
import { DutiesAndTaxesHelperService } from './services/duties-and-taxes-helper.service';
import { RDDBService } from './services/rddb.service';
import { SoaService } from './services/soa.service';
import { StepperService } from './services/stepper.service';
import { TemplatesService } from './services/templates.service';
import { DeclarationViewService } from './services/declaration-view.service';
import { DrawbackViewService } from './services/drawback-view.service';
import { EditFieldService } from './services/edit-field.service';
import { MassAdjustmentService } from './services/mass-adjustment.service';
import { AsyncValidationService } from './services/async-validations.service';
import { RoiDraftService } from './services/roi-draft.service';
import { RoiService } from './services/roi.service';
import { SDAService } from './services/sda.service';
import { CadMasterProService } from './services/cad-masterpro.service';
import { ClassifierService } from './services/classifier.service';
import { CadMetadataService } from './services/cad-metadata.service';
import { CadListService } from './services/cad-list.service';
import { CalculatorService } from './services/calculator.service';
import { TemporaryImportationDraftService } from './services/temporary-importation-draft.service';
import { TemporaryImportationService } from './services/temporary-importation.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    CadAsyncDocumentsService,
    CadLockService,
    CadService,
    DeclarationsService,
    TemplatesService,
    StepperService,
    CadDraftService,
    DutyDrawbackService,
    DutyDrawbackDraftService,
    DeclarationsAsyncValidatorsService,
    DutiesAndTaxesHelperService,
    SoaService,
    RDDBService,
    DeclarationViewService,
    DrawbackViewService,
    EditFieldService,
    AsyncValidationService,
    MassAdjustmentService,
    RoiService,
    RoiDraftService,
    SDAService,
    CadMasterProService,
    ClassifierService,
    CadMetadataService,
    CadListService,
    CalculatorService,
    TemporaryImportationService,
    TemporaryImportationDraftService
  ]
})
export class DeclarationsCoreModule {
}
